<template>
  <section id="faq-search-filter" >
    <b-card
      no-body
      class="faq-search"
      :style="{
        backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`,
        height: '300px',
      }"
    >
      <b-card-body class="text-center">
        <h2 class="text-primary">{{massage}}</h2>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import { BCard, BCardBody, BCardText } from "bootstrap-vue";
export default {
  props:["massage"],
  components: {
    BCard,
    BCardBody,
    BCardText,
  },
};
</script>

<style scoped>
</style>